<template>
    <div class="app">
        <h1>Coming soon</h1>
    </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: 'ComingSoon',
    methods: {
        ...mapActions({
            spinnerStop: 'spinner/stop'
        })
    },
    mounted () {
        this.spinnerStop()
    }
}
</script>

<style scoped>
    .app {
        position: fixed;
        left: 0;
        top: 0;
        background-image: url('../assets/img/Wave-Background-Ownership-iPhoneX.jpg');
        background-position-y: top;
        background-size: 100%;
        width: 100%;
        height: 100%;
        margin: 0 auto;
        color: #fff;
    }

    h1 {
        position: absolute;
        top: 30%;
        text-align: center;
        width: 100%;
        font-family: YummoSemiBold, sans-serif;
    }
</style>
